import { useLocation } from 'react-router-dom';
import AppRoutes from '@/routes';
import ErrorBoundary from '@/components/ErrorBoundary';
import RouteProgressBar from '@/components/RouteProgressBar';
import { useLanguageSync } from '@/i18n/useLanguageSync';

export default function App() {
  // Applies the signed-in user's saved interface language (and RTL direction).
  useLanguageSync();

  // Route path as the boundary's reset key: a crash on one screen clears as
  // soon as the user navigates somewhere else, instead of trapping them.
  const location = useLocation();

  return (
    <>
      <RouteProgressBar />
      {/* The last-resort floor. A page crashing inside AppLayout is caught by
          the layout's own boundary and keeps the navigation; this one catches
          the layouts themselves and the routes that have no layout. */}
      <ErrorBoundary resetKey={location.pathname}>
        <AppRoutes />
      </ErrorBoundary>
    </>
  );
}
